import { Accordion, AccordionItem } from '@sb1/ffe-accordion-react';
import * as React from 'react';
export default {
  Accordion,
  AccordionItem,
  React
};